/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_LETTER_TRANSLATE_IN = 'letterTranslateIn';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const letterTranslateInPresetDetails = {
  // The name of the preset.
  name: PRESET_LETTER_TRANSLATE_IN,

  // A human friendly name for the preset.
  humanName: 'Letter Translate',

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'letter.translateY': {
      time: {
        end: 'end.-2000',
        start: 'start.2000'
      },
      easing: EASINGS.easeOutExpo,
      values: [
        -50,
        -50
      ],
      stagger: 50,
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_LETTER_TRANSLATE_IN,
    options: {},
  },
};

letterTranslateInPresetDetails.template.options = lodash.cloneDeep(letterTranslateInPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_LETTER_TRANSLATE_IN;

// This defines the value of the presets object.
export default letterTranslateInPresetDetails;
